// Launch Library 2 upcoming launches. The API sends no CORS header, so the dev/preview server
// proxies it at /feed/ll2 (vite.config.ts).

import type { Fetcher } from '../types.ts';
import { getJson } from './http.ts';
import type { LiveRecord } from './types.ts';

const UPCOMING = '/feed/ll2/2.2.0/launch/upcoming/?limit=10&mode=list';
const PAD_PAGE = 'https://thespacedevs.com/llapi';
const PUBLISHER = 'The Space Devs (Launch Library 2)';

interface Ll2Launch {
  id: string;
  name: string;
  net: string;
  lsp_name: string;
  location: string;
  url: string;
}

export async function ll2Launches(fetcher: Fetcher): Promise<LiveRecord[]> {
  const doc = await getJson<{ results: Ll2Launch[] }>(fetcher, UPCOMING);
  return doc.results.map((l) => ({
    id: `ll2:${l.id}`,
    kind: 'launch' as const,
    title: `${l.name} (${l.lsp_name}), ${l.location}`,
    time: new Date(l.net).toISOString(),
    url: l.url || PAD_PAGE,
    publisher: PUBLISHER,
  }));
}
